(function (angular) {
    var DatePickerController = (function () {
        function DatePickerController() {
            this.init.apply(this, arguments);
        }

        DatePickerController.prototype = {
            init: function ($scope) {
                $scope.vm = this;
                this.$scope = $scope;
                this.date = moment(this.$scope.date, "YYYY-MM-DD");
            },
            onChange: function (key, value) {
                if (key === "selected-day") {
                    this.$scope.date = value.format("YYYY-MM-DD");
                    this.$scope.popover.hide();
                }
            },
            clear:function(){
                this.$scope.date=null;
                this.$scope.popover.hide();
            },
            close:function(){
                this.$scope.popover.hide();
            }
        };
        DatePickerController.$inject = ['$scope'];
        return DatePickerController;
    }());

    angular.module('shared').directive('nfDatePicker', function () {
        return {
            restrict: 'E',
            controller: DatePickerController,
            templateUrl: 'js/shared/directives/date-picker/date-picker.html',
            scope: {
                date: '=',
                popover: '='
            }
        };
    });

    angular.module('shared').directive('datePickerIsolateScope', function () {
        return {
            restrict: 'A',
            controller: function ($scope) {
                //hack change function to hide control if click on day
                var closeFunc = $scope.$parent.view.change;
                $scope.$parent.view.change = function (view) {
                    closeFunc.apply(this, [view]);
                    if (view == 'day') {
                        $scope.$parent.change({
                            newValue: 'selected-day',
                            oldValue: $scope.$parent.model
                        })
                    }
                }

            }
        };
    });

}(angular));